import React from "react";

export const ADMIN_GROUP = 'Admin';

export default React.createContext({
   isAdmin: false,
   isUnmanagedAdmin: false,
});
